import { useMemo } from 'react';
import { useT } from './I18nProvider';
import {
  fmtCurrency,
  fmtDate,
  fmtDateTime,
  fmtNumber,
  fmtTime,
  type FormatDateValue,
} from './format';

export interface BoundFormatters {
  fmtDate: (value: FormatDateValue, options?: Intl.DateTimeFormatOptions) => string;
  fmtTime: (value: FormatDateValue, options?: Intl.DateTimeFormatOptions) => string;
  fmtDateTime: (value: FormatDateValue, options?: Intl.DateTimeFormatOptions) => string;
  fmtNumber: (value: number, options?: Intl.NumberFormatOptions) => string;
  fmtCurrency: (
    value: number,
    currency: string,
    options?: Omit<Intl.NumberFormatOptions, 'currency' | 'style'>,
  ) => string;
}

export function useFormat(): BoundFormatters {
  const { lang } = useT();

  return useMemo(() => ({
    fmtDate: (value, options) => fmtDate(value, lang, options),
    fmtTime: (value, options) => fmtTime(value, lang, options),
    fmtDateTime: (value, options) => fmtDateTime(value, lang, options),
    fmtNumber: (value, options) => fmtNumber(value, lang, options),
    fmtCurrency: (value, currency, options) => fmtCurrency(value, currency, lang, options),
  }), [lang]);
}
